import { BaseAsset } from '../common';
import { AssetGroup } from './asset-group.model';
import { AssetStatus } from './asset-status.model';
import { AssetVariable } from './asset-variable.model';
import { AssetStatusName, CommandType } from './enums';
import { FollowedVariable } from './followed-variable';
import { Site } from './site.model';

export interface FollowedVariables {
  1: FollowedVariable | null;
  2: FollowedVariable | null;
  3: FollowedVariable | null;
}

export interface AssetDispatch {
  consumptionProfile: string | null;
  deliveryDate: string | null;
  deliveryPoint: string | null;
  forecastType: string | null;
  shipTo: string | null;
}

export enum AssetOptionalProperty {
  consumptionProfile = 'consumptionProfile',
  deliveryDate = 'deliveryDate',
  deliveryPoint = 'deliveryPoint',
  forecastType = 'forecastType',
  equipmentId = 'equipmentId',
  product1 = 'product1',
  product2 = 'product2',
  quantity1 = 'quantity1',
  quantity2 = 'quantity2',
  serialNumber = 'serialNumber',
  shipTo = 'shipTo'
}

export enum AssetUpdatableAttribute {
  name = 'name',
  status = 'status',
  equipmentId = 'equipmentId',
  serialNumber = 'serialNumber',
  shipTo = 'dispatch.shipTo'
}

export const ASSET_STATUS: AssetStatusName[] = [AssetStatusName.probation, AssetStatusName.production, AssetStatusName.maintenance];

export type AssetOptionalProperties = { [propertyName in AssetOptionalProperty]: boolean };

export interface Asset extends BaseAsset {
  assetTemplate?: { id: string };
  assetGroup?: AssetGroup;
  commands?: CommandType[] | null;
  dispatch: AssetDispatch;
  expandedVariables: { [assetVariableName: string]: Partial<AssetVariable> };
  followedVariables?: FollowedVariables;
  optionalProperties: AssetOptionalProperties;
  updatableAttributes: AssetUpdatableAttribute[];
  serialNumber: string | null;
  serviceId?: string;
  site?: Site;
  status?: AssetStatus;
  tags?: string[];
  priority?: number;
}
